import {
  FaTruck,
  FaMousePointer,
  FaMobileAlt,
  FaUndoAlt,
} from "react-icons/fa";

const features = [
  {
    icon: <FaTruck />,
    title: "Yarın Kapında",
    description: "Yarın Kapında ile ihtiyaçlarına ertesi gün sahip ol!",
  },
  {
    icon: <FaMousePointer />,
    title: "Güvenli Alışveriş",
    description:
      "Ödeme ve adres bilgilerinizi kaydedin, güvenli alışveriş yapın.",
  },
  {
    icon: <FaMobileAlt />,
    title: "Mobil Cebinizde",
    description: "Dilediğiniz her yerden güvenli alışverişin keyfini çıkarın.",
  },
  {
    icon: <FaUndoAlt />,
    title: "Kapında İade",
    description: "Aldığınız ürünü iade etmek hiç bu kadar kolay olmamıştı.",
  },
];

const FeatureSection = () => {
  return (
    <div className="bg-gray-50 text-black py-12">
      <div className="container mx-auto max-w-8xl px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center space-x-4 bg-gray-50 p-4 "
            >
              <div className="w-16 h-16 flex items-center justify-center text-orange-500 text-4xl ">
                {feature.icon}
              </div>
              <div>
                <h3 className="text-lg font-bold">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default FeatureSection;
